import { GET_FIBER_SITE_DASHBOARD } from '../../../common/constants/constants';
import apiClient from '../../../common/functions/api_axios_instance.function';
import { handleApiError } from '../../../common/functions/errorHandler.function';

export const getFiberSiteDashboard = async () => {
  try {
    const response = await apiClient.get(GET_FIBER_SITE_DASHBOARD, {});
    return response?.data?.response || response?.data;
  } catch (error) {
    handleApiError(error);
    throw error;
  }
};
